import {createSlice} from '@reduxjs/toolkit';
import {Profile} from "../../types/allTypes";

const initialState: {
  profile: Profile | undefined;
} = {
  profile: undefined,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      state.profile = action.payload;
    },
    update: (state, action) => {
      state.profile = action.payload;
    },
    logout: (state) => {
      state.profile = undefined;
    },
  },
});

export const {update, logout} = authSlice.actions;
